import React from 'react';
import { UserCircle } from 'lucide-react';

/**
 * NavItemsComponent - Handles navigation menu items and actions
 * 
 * This component renders the right-side navigation actions with enhanced visual design
 */
const NavItemsComponent = ({
  isCheckingCoverage,
  openCoverageSidebar
}) => {
  return (
    <div className="flex items-center">
      {/* WhatsApp Contact - With proper WhatsApp icon */}
      <a
        href="https://wa.me/27600672028"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors group px-4"
      >
        <div className="p-1.5 rounded-full bg-green-600/20 group-hover:bg-green-600/30 transition-all duration-300 transform group-hover:scale-105 relative">
          {/* Subtle gradient on hover */}
          <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 bg-gradient-to-tr from-green-500/0 to-green-400/10 transition-opacity duration-300"></div>
          
          {/* Proper WhatsApp SVG icon */}
          <svg className="h-4 w-4 text-green-400 group-hover:text-green-300 transition-colors duration-300 relative z-10" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
          </svg>
        </div>
        <div>
          <div className="font-bold text-sm group-hover:text-green-400 transition-colors duration-300 relative">
            WhatsApp Us
            <span className="absolute bottom-0 left-0 w-0 group-hover:w-full h-px bg-green-500/30 transition-all duration-300"></span>
          </div>
          <div className="text-xs text-gray-400 group-hover:text-gray-300 transition-colors duration-300">Quick Support</div>
        </div>
      </a>
      
      {/* Elegant separator */}
      <div className="h-8 w-px bg-gradient-to-b from-gray-800/40 via-gray-700/40 to-gray-800/40 mx-1"></div>
      
      {/* Client Portal Link - Enhanced */}
      <a
        href="https://portal.wondernet.co.za"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors group px-4"
      >
        <div className="p-1.5 rounded-full bg-blue-600/20 group-hover:bg-blue-600/30 transition-all duration-300 transform group-hover:scale-105 relative">
          {/* Subtle gradient on hover */}
          <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 bg-gradient-to-tr from-blue-500/0 to-blue-400/10 transition-opacity duration-300"></div>
          
          <UserCircle className="h-4 w-4 text-blue-400 group-hover:text-blue-300 transition-colors duration-300 relative z-10" />
        </div>
        <div>
          <div className="font-bold text-sm group-hover:text-blue-400 transition-colors duration-300 relative">
            Client Portal
            <span className="absolute bottom-0 left-0 w-0 group-hover:w-full h-px bg-blue-500/30 transition-all duration-300"></span>
          </div>
          <div className="text-xs text-gray-400 group-hover:text-gray-300 transition-colors duration-300">Manage Account</div>
        </div>
      </a>
    </div>
  );
};

export default NavItemsComponent;